import Link from "next/link";
import { safeJsonLd } from "@/utils/jsonLd";
import { BASE_URL_CITY } from "@/data/assetData";

function MainBreadcrumb({ seoAllData = [], variant = "default", staticBgClass = "bg-gray-50" }) {
  const breadcrumbs = [{ name: "Home", url: "/" }, ...seoAllData];
  const isStatic = variant === "static";

  // Schema URLs must match canonical (trailingSlash: true in next.config.mjs).
  // Callers sometimes pass paths without a trailing slash — normalize here.
  const toAbsolute = (path) => {
    const url = `${BASE_URL_CITY || ""}${path || "/"}`;
    return url.endsWith("/") ? url : `${url}/`;
  };

  const breadcrumbSchema = {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    itemListElement: breadcrumbs.map((breadcrumb, index) => ({
      "@type": "ListItem",
      position: index + 1,
      name: breadcrumb.name,
      item: toAbsolute(breadcrumb.url),
    })),
  };

  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: safeJsonLd(breadcrumbSchema) }}
      />

      {breadcrumbs.length > 1 && (
        <nav
          aria-label="breadcrumb"
          className={
            isStatic
              ? `relative mt-0 text-gray-700 z-[1] ${staticBgClass} py-2 pl-4 max-[844px]:pl-2`
              : "absolute pl-2 mt-[5px] text-white z-[6] lg:mt-[62px] lg:pl-4"
          }
        >
          <ol className="flex items-center text-sm p-2">
            {(() => {
              const visible = breadcrumbs.filter((b) => typeof b.url === "string" && b.url.length > 0);
              return visible.map((breadcrumb, index) => (
                <li key={breadcrumb.url || index}>
                  <Link
                    href={breadcrumb.url}
                    aria-label={breadcrumb.name}
                    className={
                      isStatic
                        ? "text-gray-700 no-underline hover:text-amber-500"
                        : "text-inherit no-underline hover:underline"
                    }
                  >
                    {breadcrumb.name}
                  </Link>
                  {index < visible.length - 1 && <span className="mx-2">&#62;</span>}
                </li>
              ));
            })()}
          </ol>
        </nav>
      )}
    </>
  );
}

export default MainBreadcrumb;
